import { useTranslations } from 'next-intl'
import { isNil } from 'lodash'
import { ImportJobStatus } from '../models/importModels'
import Badge, { BadgeProps } from '@/shared/v2/shared/components/Badge'

type ImportStatusBadgeProps = {
    status: ImportJobStatus | undefined
}

const ImportStatusBadge = ({ status }: ImportStatusBadgeProps) => {
    const t = useTranslations('imports')

    const resolveBadgeIntent = (): BadgeProps['intent'] => {
        switch (status) {
            case 'pending':
            case 'processing':
            case 'processed_with_errors':
                return 'warning'
            case 'completed':
                return 'positive'
            case 'failed':
                return 'negative'
            default:
                return 'default'
        }
    }

    return !isNil(status) ? (
        <Badge data-testid="__import-status-badge__" intent={resolveBadgeIntent()}>
            {t.has(`status.${status}`) ? t(`status.${status}`) : status.toUpperCase()}
        </Badge>
    ) : null
}

export default ImportStatusBadge
